'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Button');
var dom = videojs.dom || videojs;
/**
 * add video
 */

var AddChapterButton = function (_Component) {
  inherits(AddChapterButton, _Component);

  function AddChapterButton(player, options) {
    classCallCheck(this, AddChapterButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-chapter-button');
    _this.content_();

    return _this;
  }

  AddChapterButton.prototype.handleClick = function handleClick() {
    this.player().trigger('chapter:opened');
  };

  AddChapterButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddChapterButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddChapterButton;
}(Component);

var Component$1 = videojs.getComponent('Button');
var dom$1 = videojs.dom || videojs;
/**
 * add video
 */

var AddQuizButton = function (_Component) {
  inherits(AddQuizButton, _Component);

  function AddQuizButton(player, options) {
    classCallCheck(this, AddQuizButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-quiz-button');
    _this.content_();
    return _this;
  }

  AddQuizButton.prototype.handleClick = function handleClick() {
    this.player().trigger('quiz:opened');
  };

  AddQuizButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddQuizButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddQuizButton;
}(Component$1);

var Component$2 = videojs.getComponent('Button');
var dom$2 = videojs.dom || videojs;
/**
 * add video
 */

var AddSondageButton = function (_Component) {
  inherits(AddSondageButton, _Component);

  function AddSondageButton(player, options) {
    classCallCheck(this, AddSondageButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-sondage-button');
    _this.content_();
    return _this;
  }

  AddSondageButton.prototype.handleClick = function handleClick() {
    this.player().trigger('sondage:opened');
  };

  AddSondageButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddSondageButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddSondageButton;
}(Component$2);

var Component$3 = videojs.getComponent('Button');
var dom$3 = videojs.dom || videojs;
/**
 * add video
 */

var AddAnnotationButton = function (_Component) {
  inherits(AddAnnotationButton, _Component);

  function AddAnnotationButton(player, options) {
    classCallCheck(this, AddAnnotationButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-annotation-button');
    _this.content_();
    return _this;
  }

  AddAnnotationButton.prototype.handleClick = function handleClick() {
    this.player().trigger('annotation:opened');
  };

  AddAnnotationButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddAnnotationButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddAnnotationButton;
}(Component$3);

var Component$4 = videojs.getComponent('Button');
var dom$4 = videojs.dom || videojs;
/**
 * add video
 */

var SaveButton = function (_Component) {
  inherits(SaveButton, _Component);

  function SaveButton(player, options) {
    classCallCheck(this, SaveButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-save-btn');
    _this.content_();
    return _this;
  }

  SaveButton.prototype.handleClick = function handleClick() {
    this.player().trigger('save:clicked');
  };

  SaveButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="dot"></span><span class="vjs-custom-control-text">' + this.player().localize('SaveButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return SaveButton;
}(Component$4);

var Component$5 = videojs.getComponent('Button');
var dom$5 = videojs.dom || videojs;
/**
 * add video
 */

var CTAButton = function (_Component) {
  inherits(CTAButton, _Component);

  function CTAButton(player, options) {
    classCallCheck(this, CTAButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-cta-btn');
    _this.content_();
    return _this;
  }

  CTAButton.prototype.handleClick = function handleClick() {
    this.player().trigger('cta:clicked');
  };

  CTAButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('CTAButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return CTAButton;
}(Component$5);

var Component$6 = videojs.getComponent('Button');
var dom$6 = videojs.dom || videojs;
/**
 * add video
 */

var PreviewButton = function (_Component) {
  inherits(PreviewButton, _Component);

  function PreviewButton(player, options) {
    classCallCheck(this, PreviewButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-preview-btn');
    _this.content_();
    return _this;
  }

  PreviewButton.prototype.handleClick = function handleClick() {
    this.player().trigger('preview:clicked');
  };

  PreviewButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('PreviewButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return PreviewButton;
}(Component$6);

var Component$7 = videojs.getComponent('Button');
var dom$7 = videojs.dom || videojs;
/**
 * add video
 */

var AddHiddenAreaButton = function (_Component) {
  inherits(AddHiddenAreaButton, _Component);

  function AddHiddenAreaButton(player, options) {
    classCallCheck(this, AddHiddenAreaButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-area-hidden-btn');
    _this.content_();
    return _this;
  }

  AddHiddenAreaButton.prototype.handleClick = function handleClick() {
    console.log('hidden-area:opened');
    this.player().trigger('hidden-area:opened');
  };

  AddHiddenAreaButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddHiddenAreaButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddHiddenAreaButton;
}(Component$7);

var Component$8 = videojs.getComponent('Button');
var dom$8 = videojs.dom || videojs;
/**
 * add video
 */

var AddQuestionButton = function (_Component) {
  inherits(AddQuestionButton, _Component);

  function AddQuestionButton(player, options) {
    classCallCheck(this, AddQuestionButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.addClass('vjs-add-question-button');
    _this.content_();
    return _this;
  }

  AddQuestionButton.prototype.handleClick = function handleClick() {
    this.player.trigger('question:opened');
  };

  AddQuestionButton.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player.localize('AddQuestionButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddQuestionButton;
}(Component$8);

var Component$9 = videojs.getComponent('Button');
var dom$9 = videojs.dom || videojs;
/**
 * add video
 */

var AddIndexIndicator = function (_Component) {
  inherits(AddIndexIndicator, _Component);

  function AddIndexIndicator(player, options) {
    classCallCheck(this, AddIndexIndicator);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  AddIndexIndicator.prototype.createEl = function createEl() {
    var el = videojs.dom.createEl('div', {
      className: 'vjs-indicator vjs-indicator-index'
    });
    this.name = videojs.dom.createEl('span', {
      className: 'vjs-indicator-name',
      id: 'vjs-indicator-name',
      textContent: this.player().localize('index')
    });

    el.appendChild(this.name);

    var arrow = videojs.dom.createEl('div', {
      className: 'vjs-indicator-arrow'
    });

    el.appendChild(arrow);

    return el;
  };

  return AddIndexIndicator;
}(Component$9);

var Component$10 = videojs.getComponent('Button');
var dom$10 = videojs.dom || videojs;
/**
 * add video
 */

var AddSlideIndicator = function (_Component) {
  inherits(AddSlideIndicator, _Component);

  function AddSlideIndicator(player, options) {
    classCallCheck(this, AddSlideIndicator);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  AddSlideIndicator.prototype.createEl = function createEl() {
    var el = videojs.dom.createEl('div', {
      className: 'vjs-indicator-slide vjs-indicator'
    });
    this.name = videojs.dom.createEl('span', {
      className: 'vjs-indicator-name',
      id: 'vjs-indicator-name',
      textContent: this.player().localize('slide')
    });

    el.appendChild(this.name);

    var arrow = videojs.dom.createEl('div', {
      className: 'vjs-indicator-arrow'
    });

    el.appendChild(arrow);

    return el;
  };

  return AddSlideIndicator;
}(Component$10);

var Component$11 = videojs.getComponent('Button');
var dom$11 = videojs.dom || videojs;
/**
 * add video
 */

var AddCaptureSlide = function (_Component) {
  inherits(AddCaptureSlide, _Component);

  function AddCaptureSlide(player, options) {
    classCallCheck(this, AddCaptureSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-capture-button');
    _this.content_();

    return _this;
  }

  AddCaptureSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('thumb:opened');
  };

  AddCaptureSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddCaptureButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddCaptureSlide;
}(Component$11);

var Component$12 = videojs.getComponent('Button');
var dom$12 = videojs.dom || videojs;
/**
 * add video
 */

var AddImageSlide = function (_Component) {
  inherits(AddImageSlide, _Component);

  function AddImageSlide(player, options) {
    classCallCheck(this, AddImageSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-image-button');
    _this.content_();

    return _this;
  }

  AddImageSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('slide:opened');
  };

  AddImageSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddImageButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddImageSlide;
}(Component$12);

var Component$13 = videojs.getComponent('Button');
var dom$13 = videojs.dom || videojs;
/**
 * add video
 */

var AddVideoSlide = function (_Component) {
  inherits(AddVideoSlide, _Component);

  function AddVideoSlide(player, options) {
    classCallCheck(this, AddVideoSlide);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-add-video-button');
    _this.content_();

    return _this;
  }

  AddVideoSlide.prototype.handleClick = function handleClick() {
    this.player().trigger('video:opened');
  };

  AddVideoSlide.prototype.content_ = function content_() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div class="vjs-custom-control-arrow"></div><span class="vjs-custom-control-text">' + this.player().localize('AddVideoButton') + '</span>';
    this.el_.innerHTML = wrapper.innerHTML;
  };

  return AddVideoSlide;
}(Component$13);

var Component$14 = videojs.getComponent('Button');
var dom$14 = videojs.dom || videojs;
var types = {
  "chapter": 'C',
  "question": '?',
  "annotation": 'A',
  "quiz": 'Q',
  "sondage": 'S',
  "hidden-area": 'H'
};
var NULL_INDEX = -1;
var defaultSetting = {
  markerStyle: {
    'width': "12px",
    'border-radius': "50%",
    'background-color': "#4e90c8",
    'height': "12px",
    'left': "8.74057%",
    'margin-left': "0px",
    'border': "2px",
    'border-color': "#d0d0d0",
    'border-style': "solid",
    'top': "-3px"
  },
  markerTip: {
    display: true,
    text: function text(marker) {
      return marker.type;
    },
    time: function time(marker) {
      return marker.start;
    }
  },
  breakOverlay: {
    display: false,
    displayTime: 3,
    text: function text(marker) {
      return "Break overlay: " + marker.overlayText;
    },
    style: {
      'width': '100%',
      'height': '20%',
      'background-color': 'rgba(0,0,0,0.7)',
      'color': 'white',
      'font-size': '17px'
    }
  },
  onMarkerClick: function onMarkerClick(marker) {},
  onMarkerReached: function onMarkerReached(marker, index) {},
  markers: []
};
var markersList = [];

var ControlBarMarkers = function (_Component) {
  inherits(ControlBarMarkers, _Component);

  function ControlBarMarkers(player, options) {
    classCallCheck(this, ControlBarMarkers);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.registerVideoJsMarkersPlugin(options);
    _this.player.on("deleteMarker", _this.deleteMarker);
    _this.player.on("modifyMarker", _this.modifyMarker);
    _this.player.on("addMarker", _this.addMarker);
    // default setting
    return _this;
  }

  // create a non-colliding random number


  ControlBarMarkers.prototype.addMarker = function addMarker(event, markers) {
    this.markers.add(markers);
  };

  ControlBarMarkers.prototype.modifyMarker = function modifyMarker(event, data) {
    var markers = this.markers.getMarkers();
    var indexToRemove = markers.findIndex(function (m) {
      return m.start === data.old.start;
    });
    this.markers.remove([indexToRemove]);
    this.markers.add([data.updated]);
  };

  ControlBarMarkers.prototype.deleteMarker = function deleteMarker(event, marker) {
    var markers = this.markers.getMarkers();
    var indexToRemove = markers.findIndex(function (m) {
      return m.start === marker.start;
    });
    this.markers.remove([indexToRemove]);
  };

  ControlBarMarkers.prototype.generateUUID = function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
    return uuid;
  };

  /**
   * Returns the size of an element and its position
   * a default Object with 0 on each of its properties
   * its return in case there's an error
   * @param  {Element} element  el to get the size and position
   * @return {DOMRect|Object}   size and position of an element
   */
  ControlBarMarkers.prototype.registerVideoJsMarkersPlugin = function registerVideoJsMarkersPlugin(options) {

    var setting = videojs.mergeOptions(defaultSetting, options),
        markersMap = {},
        currentMarkerIndex = NULL_INDEX,
        markerTip = null,
        breakOverlay = null,
        overlayIndex = NULL_INDEX;
    var self = this;

    function sortMarkersList() {
      // sort the list by time in asc order
      markersList.sort(function (a, b) {
        return setting.markerTip.time(a) - setting.markerTip.time(b);
      });
    }

    function getElementBounding(element) {
      var elementBounding;
      var defaultBoundingRect = {
        top: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        right: 0
      };

      try {
        elementBounding = element.getBoundingClientRect();
      } catch (e) {
        elementBounding = defaultBoundingRect;
      }

      return elementBounding;
    }

    function addMarkers(newMarkers) {
      newMarkers.forEach(function (marker) {
        marker.key = self.generateUUID();

        self.player.el().querySelector('.vjs-progress-holder').appendChild(createMarkerDiv(marker));

        // store marker in an internal hash map
        markersMap[marker.key] = marker;
        markersList.push(marker);
      });

      sortMarkersList();
    }

    function getPosition(marker) {
      return setting.markerTip.time(marker) / self.player.duration() * 100;
    }

    function setMarkderDivStyle(marker, markerDiv) {
      markerDiv.className = 'vjs-marker ' + (marker['class'] || "");

      Object.keys(setting.markerStyle).forEach(function (key) {
        markerDiv.style[key] = setting.markerStyle[key];
      });

      // hide out-of-bound markers
      var ratio = marker.time / self.player.duration();
      if (ratio < 0 || ratio > 1) {
        markerDiv.style.display = 'none';
      }

      // set position
      markerDiv.style.left = getPosition(marker) + '%';

      var markerDivBounding = getElementBounding(markerDiv);
      markerDiv.style.marginLeft = markerDivBounding.width / 2 + 'px';
    }

    function createMarkerDiv(marker) {

      var markerDiv = videojs.dom.createEl('div', {}, {
        'data-marker-key': marker.key,
        'data-marker-time': setting.markerTip.time(marker)
      });
      var type = types[marker.type] ? types[marker.type] : ' ';
      markerDiv.innerHTML = '<span class="type">' + type + '</span>';
      setMarkderDivStyle(marker, markerDiv);

      // bind click event to seek to marker time
      markerDiv.addEventListener('click', function (e) {
        var preventDefault = false;
        self.player.pause();
        self.player.trigger('modify:opened', marker);
        if (typeof setting.onMarkerClick === "function") {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }

        if (!preventDefault) {
          var key = this.getAttribute('data-marker-key');
          self.player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      });

      if (setting.markerTip.display) {
        registerMarkerTipHandler(markerDiv);
      }

      return markerDiv;
    }

    function updateMarkers(force) {
      // update UI for markers whose time changed
      markersList.forEach(function (marker) {
        var markerDiv = self.player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
        var markerTime = setting.markerTip.time(marker);

        if (force || markerDiv.getAttribute('data-marker-time') !== markerTime) {
          setMarkderDivStyle(marker, markerDiv);
          markerDiv.setAttribute('data-marker-time', markerTime);
        }
      });
      sortMarkersList();
    }

    function removeMarkers(indexArray) {
      // reset overlay
      if (!!breakOverlay) {
        overlayIndex = NULL_INDEX;
        breakOverlay.style.visibility = "hidden";
      }
      currentMarkerIndex = NULL_INDEX;

      var deleteIndexList = [];
      indexArray.forEach(function (index) {
        var marker = markersList[index];
        if (marker) {
          // delete from memory
          delete markersMap[marker.key];
          deleteIndexList.push(index);

          // delete from dom
          var el = self.player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
          el && el.parentNode.removeChild(el);
        }
      });

      // clean up markers array
      deleteIndexList.reverse();
      deleteIndexList.forEach(function (deleteIndex) {
        markersList.splice(deleteIndex, 1);
      });

      // sort again
      sortMarkersList();
    }

    // attach hover event handler
    function registerMarkerTipHandler(markerDiv) {
      markerDiv.addEventListener('mouseover', function () {
        var marker = markersMap[markerDiv.getAttribute('data-marker-key')];
        if (!!markerTip) {
          markerTip.querySelector('.vjs-tip-inner').innerText = self.player.localize(setting.markerTip.text(marker));
          // margin-left needs to minus the padding length to align correctly with the marker
          // markerTip.style.left = getPosition(marker) + '%';
          var left = getPosition(marker) / 100;
          var markerTipBounding = getElementBounding(markerTip);
          var markerDivBounding = getElementBounding(markerDiv);
          var parent = getElementBounding(document.querySelector(".vjs-progress-control"));
          if (parseFloat(parent.width * left) < parseFloat(markerTipBounding.width / 2)) {
            markerTip.style.left = "0%";
            markerTip.style.marginLeft = "0px";
          } else if (parseFloat(parent.width * left) + parseFloat(markerTipBounding) > parseFloat(parent.width)) {
            markerTip.style.left = parseFloat(parent.width) + parseFloat(markerTipBounding) + "%";
            markerTip.style.marginLeft = "0px";
          } else {
            markerTip.style.left = getPosition(marker) + '%';
            markerTip.style.marginLeft = -parseFloat(markerTipBounding.width / 2) + parseFloat(markerDivBounding.width / 4) + 'px';
          }

          markerTip.style.visibility = 'visible';
        }
      });

      markerDiv.addEventListener('mouseout', function () {
        if (!!markerTip) {
          markerTip.style.visibility = "hidden";
        }
      });
    }

    function initializeMarkerTip() {
      markerTip = videojs.dom.createEl('div', {
        className: 'vjs-tip',
        innerHTML: "<div class='vjs-tip-arrow'></div><div class='vjs-tip-inner'></div>"
      });
      self.player.el().querySelector('.vjs-progress-holder').appendChild(markerTip);
    }

    // show or hide break overlays
    function updateBreakOverlay() {
      if (!setting.breakOverlay.display || currentMarkerIndex < 0) {
        return;
      }

      var currentTime = self.player.currentTime();
      var marker = markersList[currentMarkerIndex];
      var markerTime = setting.markerTip.time(marker);

      if (currentTime >= markerTime && currentTime <= markerTime + setting.breakOverlay.displayTime) {
        if (overlayIndex !== currentMarkerIndex) {
          overlayIndex = currentMarkerIndex;
          if (breakOverlay) {
            breakOverlay.querySelector('.vjs-break-overlay-text').innerHTML = setting.breakOverlay.text(marker);
          }
        }

        if (breakOverlay) {
          breakOverlay.style.visibility = "visible";
        }
      } else {
        overlayIndex = NULL_INDEX;
        if (breakOverlay) {
          breakOverlay.style.visibility = "hidden";
        }
      }
    }

    // problem when the next marker is within the overlay display time from the previous marker
    function initializeOverlay() {
      breakOverlay = videojs.dom.createEl('div', {
        className: 'vjs-break-overlay',
        innerHTML: "<div class='vjs-break-overlay-text'></div>"
      });
      Object.keys(setting.breakOverlay.style).forEach(function (key) {
        if (breakOverlay) {
          breakOverlay.style[key] = setting.breakOverlay.style[key];
        }
      });
      self.player.el().appendChild(breakOverlay);
      overlayIndex = NULL_INDEX;
    }

    function onTimeUpdate() {
      onUpdateMarker();
      updateBreakOverlay();
      self.options.onTimeUpdateAfterMarkerUpdate && self.options.onTimeUpdateAfterMarkerUpdate();
    }

    function onUpdateMarker() {
      /*
        check marker reached in between markers
        the logic here is that it triggers a new marker reached event only if the player
        enters a new marker range (e.g. from marker 1 to marker 2). Thus, if player is on marker 1 and user clicked on marker 1 again, no new reached event is triggered)
      */
      if (!markersList.length) {
        return;
      }

      var getNextMarkerTime = function getNextMarkerTime(index) {
        if (index < markersList.length - 1) {
          return setting.markerTip.time(markersList[index + 1]);
        }
        // next marker time of last marker would be end of video time
        return self.player.duration();
      };
      var currentTime = self.player.currentTime();
      var newMarkerIndex = NULL_INDEX;

      if (currentMarkerIndex !== NULL_INDEX) {
        // check if staying at same marker
        var nextMarkerTime = getNextMarkerTime(currentMarkerIndex);
        if (currentTime >= setting.markerTip.time(markersList[currentMarkerIndex]) && currentTime < nextMarkerTime) {
          return;
        }

        // check for ending (at the end current time equals player duration)
        if (currentMarkerIndex === markersList.length - 1 && currentTime === self.player.duration()) {
          return;
        }
      }

      // check first marker, no marker is selected
      if (currentTime < setting.markerTip.time(markersList[0])) {
        newMarkerIndex = NULL_INDEX;
      } else {
        // look for new index
        for (var i = 0; i < markersList.length; i++) {
          nextMarkerTime = getNextMarkerTime(i);
          if (currentTime >= setting.markerTip.time(markersList[i]) && currentTime < nextMarkerTime) {
            newMarkerIndex = i;
            break;
          }
        }
      }

      // set new marker index
      if (newMarkerIndex !== currentMarkerIndex) {
        // trigger event if index is not null
        if (newMarkerIndex !== NULL_INDEX && self.options.onMarkerReached) {
          self.options.onMarkerReached(markersList[newMarkerIndex], newMarkerIndex);
        }
        currentMarkerIndex = newMarkerIndex;
      }
    }

    // setup the whole thing
    function initialize() {
      if (setting.markerTip.display) {
        initializeMarkerTip();
      }

      // remove existing markers if already initialized
      self.player.markers.removeAll();
      addMarkers(setting.markers);

      if (setting.breakOverlay.display) {
        initializeOverlay();
      }
      onTimeUpdate();
      self.player.on("timeupdate", onTimeUpdate);
      self.player.off("loadedmetadata");
    }

    // setup the plugin after we loaded video's meta data
    self.player.on("loadedmetadata", function () {
      initialize();
    });

    // exposed plugin API
    self.player.markers = {
      getMarkers: function getMarkers() {
        return markersList;
      },
      next: function next() {
        // go to the next marker from current timestamp
        var currentTime = this.player.currentTime();
        for (var i = 0; i < markersList.length; i++) {
          var markerTime = setting.markerTip.time(markersList[i]);
          if (markerTime > currentTime) {
            this.player.currentTime(markerTime);
            break;
          }
        }
      },
      prev: function prev() {
        // go to previous marker
        var currentTime = this.player.currentTime();
        for (var i = markersList.length - 1; i >= 0; i--) {
          var markerTime = setting.markerTip.time(markersList[i]);
          // add a threshold
          if (markerTime + 0.5 < currentTime) {
            this.player.currentTime(markerTime);
            return;
          }
        }
      },
      add: function add(newMarkers) {
        // add new markers given an array of index
        addMarkers(newMarkers);
      },
      remove: function remove(indexArray) {
        // remove markers given an array of index
        removeMarkers(indexArray);
      },
      removeAll: function removeAll() {
        var indexArray = [];
        for (var i = 0; i < markersList.length; i++) {
          indexArray.push(i);
        }
        removeMarkers(indexArray);
      },
      // force - force all markers to be updated, regardless of if they have changed or not.
      updateTime: function updateTime(force) {
        // notify the plugin to update the UI for changes in marker times
        updateMarkers(force);
      },
      reset: function reset(newMarkers) {
        // remove all the existing markers and add new ones
        this.player.markers.removeAll();
        addMarkers(newMarkers);
      },
      destroy: function destroy() {
        // unregister the plugins and clean up even handlers
        this.player.markers.removeAll();
        breakOverlay && breakOverlay.remove();
        markerTip && markerTip.remove();
        this.player.off("timeupdate", updateBreakOverlay);
        delete this.player.markers;
      }
    };
  };

  return ControlBarMarkers;
}(Component$14);

// Default options for the plugin.
var defaults = {
  buttons: ["addChapter", "addQuiz"]
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

videojs.registerComponent('AddCaptureSlide', AddCaptureSlide);
videojs.registerComponent('AddImageSlide', AddImageSlide);
videojs.registerComponent('AddVideoSlide', AddVideoSlide);
videojs.registerComponent('AddChapterButton', AddChapterButton);
videojs.registerComponent('AddQuizButton', AddQuizButton);
videojs.registerComponent('AddAnnotationButton', AddAnnotationButton);
videojs.registerComponent('AddSondageButton', AddSondageButton);
videojs.registerComponent('SaveButton', SaveButton);
videojs.registerComponent('CTAButton', CTAButton);
videojs.registerComponent('PreviewButton', PreviewButton);
videojs.registerComponent('AddHiddenAreaButton', AddHiddenAreaButton);
videojs.registerComponent('AddQuestionButton', AddQuestionButton);
videojs.registerComponent('AddIndexIndicator', AddIndexIndicator);
videojs.registerComponent('AddSlideIndicator', AddSlideIndicator);
videojs.registerComponent('ControlBarMarkers', ControlBarMarkers);

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-ultimate');
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddIndexIndicator', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddChapterButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddQuizButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddSondageButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddAnnotationButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddQuestionButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('CTAButton', options);
  player.getChild('controlBar').getChild("CustomControlSpacer").addChild('AddHiddenAreaButton', options);
  player.getChild('controlBar').addChild('SaveButton', options);
  player.getChild('controlBar').addChild('PreviewButton', options);

  var buttonsContainer = document.querySelector('.timeline-buttons');
  if (buttonsContainer.childNodes.length === 0) {
    var image = new AddImageSlide(player, options);
    var video = new AddVideoSlide(player, options);
    var thumb = new AddCaptureSlide(player, options);
    buttonsContainer.appendChild(image.el_);
    buttonsContainer.appendChild(video.el_);
    buttonsContainer.appendChild(thumb.el_);
  }

  var markers = {
    markerTip: {
      display: true
    } };
  markers.markers = options.data.interactivity.concat(options.data.annotations);
  var markers = new ControlBarMarkers(player, markers);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function ultimate
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

var ultimate = function ultimate(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('ultimate', ultimate);

// Include the version number.
ultimate.VERSION = version;

module.exports = ultimate;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_ultimate/dist/videojs-ultimate.cjs.js
// module id = 564
// module chunks = 1